import { Button } from '@mui/material'
import { ApplicationTypes } from 'metalworks-domain'
import { useCallback } from 'react'

import { PhxIcon } from '@salsita-ai/platform-project-sdk/ui'

import { configuratorInterface } from '../../systems/configurator-interface'

export const FinalizeButton = () => {
  const navigate = configuratorInterface.useNavigate()

  const handleClick = useCallback(() => {
    navigate(ApplicationTypes.NavigationState.Finalization)
  }, [navigate])

  return (
    <Button endIcon={<PhxIcon name="ArrowRight" />} onClick={handleClick} fullWidth variant="contained" color="primary">
      Next
    </Button>
  )
}
